module.exports = __webpack_public_path__ + "img/CAPT_Daluz.f63a085d.jpg";